(function () {
  if (window.__gsInit) return;
  window.__gsInit = true;

  document.querySelectorAll('.gs .thumb').forEach(function (thumb) {
    if (thumb.style.display === 'none') return;
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('.gallery');
      if (!gallery) return;
      gallery.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = gallery.querySelector('.main-img img');
      var src = thumb.dataset.image;
      if (mainImg && src) mainImg.src = src;
    });
  });

  document.querySelectorAll('.gs .faq button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var faq = btn.parentElement;
      var ans = btn.nextElementSibling;
      var open = faq.classList.contains('open');
      faq.classList.toggle('open');
      ans.style.maxHeight = open ? null : ans.scrollHeight + 'px';
    });
  });

  var buybox = document.querySelector('.gs .buybox');
  var bar = document.querySelector('.gs .stickybar');
  if (buybox && bar) {
    window.addEventListener('scroll', function () {
      var past = buybox.getBoundingClientRect().bottom < 0;
      var nearFooter = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 380);
      bar.classList.toggle('show', past && !nearFooter);
    });
  }

  var tabs = [].slice.call(document.querySelectorAll('.gs .tabnav a'));
  var secs = tabs.map(function (t) {
    try { return document.querySelector(t.getAttribute('href')); } catch (e) { return null; }
  });
  function offTop(el) {
    var t = 0;
    while (el) { t += el.offsetTop; el = el.offsetParent; }
    return t;
  }
  function syncTabs() {
    var y = window.scrollY + 150, act = 0, best = -1;
    secs.forEach(function (s, i) {
      if (s) { var o = offTop(s); if (o <= y && o > best) { best = o; act = i; } }
    });
    tabs.forEach(function (t, i) { t.classList.toggle('active', i === act); });
  }
  if (tabs.length) {
    window.addEventListener('scroll', syncTabs);
    syncTabs();
  }

  document.querySelectorAll('.gs [data-story-video]').forEach(function (media) {
    var playBtn = media.querySelector('.gs-story-play');
    var poster = media.querySelector('.gs-story-poster');
    var videoWrap = media.querySelector('.gs-story-video');
    if (!playBtn || !videoWrap) return;

    var video = videoWrap.querySelector('video');
    var iframe = videoWrap.querySelector('iframe');

    playBtn.addEventListener('click', function () {
      media.classList.add('is-playing');
      playBtn.hidden = true;
      if (poster) poster.hidden = true;
      videoWrap.hidden = false;

      if (video) {
        video.play();
        return;
      }

      if (iframe && iframe.dataset.src && !iframe.src) {
        iframe.src = iframe.dataset.src;
      }
    });
  });
})();
